export default function() {

  const parent = '.js-accordion',
        child  = '.js-accordionChild'

  $(parent).on('click', function() {
    const currentChild = $(this).next(child),
          childHeight  = currentChild.children('div').outerHeight(true)
    if (currentChild.hasClass('open')) {
      // close
      $(this).removeClass('active')
      currentChild.removeClass('open').css('height', '')
    } else {
      // open
      $(this).addClass('active')
      currentChild.addClass('open').css('height', childHeight)
    }
  })

}



// WEBPACK FOOTER //
// ./src/assets/js/modules/accordion.js